export const MASS_TITLE = {
  SIGN: "Подписание документов",
  VISE: "Визирование документов",
};

export enum SIGNING_STATUSES {
  CHECKING_SIGNING_POSSIBILITY = "CHECKING_SIGNING_POSSIBILITY",
  READY_TO_BE_SIGNED = "READY_TO_BE_SIGNED",
  IS_SIGNING = "IS_SIGNING",
  SIGNING_STOPPED = "SIGNING_STOPPED",
  SIGNING_COMPLETED = "SIGNING_COMPLETED",
  ERROR = "ERROR",
}

export const INIT_DOCUMENTS_INFO = {
  totalDocuments: {},
  validDocuments: {},
  signedDocuments: {},
};

export const CURRENCY_AMOUNT_INFO = "на сумму";

export const DOCUMENT_TYPES_DICTIONARY = {
  PAYMENT_ORDER: "Платёжное поручение",
  PAYMENT_DEMAND: "Платёжное требование",
  PAYMENT_INCASOO: "Инкассовое поручение",
  CURRENCY_CONVERSION: "Конверсионный документ",
  PAYMENT_ORDER_CURRENCY: "Валютный перевод",
  TRANSIT_ACCOUNT_ORDER: "Распоряжение по валютному счёту",
  RU_PAYMENT_FOR_CONTROL: "Платёжное поручение в рублях на контроле",
  TRANSIT_ACCOUNT_PAYMENT_FOR_CONTROL:
    "Распоряжение по транзитному счёту на контроле",
  FCY_PAYMENT_FOR_CONTROL: "Валютный перевод на контроле",
};

export const UNKNOWN_SIGNATURE_CHECK_ERROR =
  "Ошибка проверки подписи документа";

export const UNKNOWN_ERROR = "Неизвестная ошибка";

export const DOCUMENT_SIGNING_ERROR = "Не удалось подписать документ";

export enum TASK_STATUS {
  VERIFIED = "VERIFIED",
  FINISHED = "FINISHED",
}

export const ACCORDION_DATA_ERROR =
  "Не удалось получить подписываемые данные для документов";

export const RUB = "RUB";

export const RUR = "RUR";

export type DOCUMENT_SIGNING_STAGES_TYPE =
  typeof DOCUMENT_SIGNING_STAGES[keyof typeof DOCUMENT_SIGNING_STAGES];

export const DOCUMENT_SIGNING_STAGES = {
  /** Документ не начал процедуру подписания */
  EMPTY: -1,
  /** У документа получен ККБ */
  GOT_CCB: 1,
  /** Документ локально подписан (успешно/ошибка) */
  SIGNED_LOCALLY: 2,
  /** По документу отправлен запрос на сервер. Ответ не получен */
  SIGNATURE_IS_CHECKING: 3,
  /** Ответ с сервера по документу получен (FINISHED) */
  FINISHED: 4,
  /** Получили ошибку по документу */
  FINISHED_WITH_ERROR: 5,
};

export const DOCUMENT_PLURAL_FORMS = ["документ", "документа", "документов"];
export const SELECTED_PLURAL_FORMS = ["Выбран", "Выбрано", "Выбрано"];
export const RUBLE_PLURAL_FORMS = ["рублевый", "рублевых", "рублевых"];

export const SIGNING_TYPES = {
  SIGN: "SIGN",
  VISE: "VISE",
} as const;

export const SIGNING_PLURAL_FORMS = {
  [SIGNING_TYPES.SIGN]: ["Подписан", "Подписано", "Подписано"],
  [SIGNING_TYPES.VISE]: ["Завизирован", "Завизировано", "Завизировано"],
};

export const DOCUMENT_SIGNING_STATUSES = {
  IN_PROGRESS: "CCB_FINISHED",
  ERROR: "SIGNING_FAULT",
  SUCCESS: "FINISHED",
};

export const SIGNING_REQUEST_INTERVAL_DEFAULT = 3;

export const DOCUMENTS_IN_BATCH_DEFAULT = 10;

export const SYSTEM_SHORT_NAMES = {
  MICROSERVICE: "ms",
  MONOLITH: "monolith",
};

export const SIGNING_UNAVAILABLE_REASON = {
  UNSIGNED_DOC: "Документ не может быть подписан",
  UNSIGNED_DOC_STATUS: "Документ не может быть подписан в этом статусе",
};

export const SIGNATURE_INFO_DEFAULT = {
  ccbInfo: null,
  signature: "",
  error: "",
  signingStage: DOCUMENT_SIGNING_STAGES.EMPTY,
};

export const DOCUMENT_STATUS_DEFAULT = {
  status: "",
  errorText: "",
};

export const INVALID_PIN_CODE_ERROR = "0x8010006B";
export const CANCEL_PIN_CODE_WINDOW_BY_USER_CODE_ERROR = "0x8010006E";
export const CANCEL_CONFIRM_CERT_WINDOW_BY_USER_CODE_ERROR = "0x000004C7";
export const CANCEL_CONFIRM_WINDOW_BY_USER_ANNOTATION =
  "Действие отменено пользователем";

export enum CUSTOM_ERROR_KEYS {
  INVALID_PINCODE = "INVALID_PINCODE",
  EXCEEDED_THE_LIMIT = "EXCEEDED_THE_LIMIT",
  ACTIVE_CERTIFICATE_NOT_FOUND = "ACTIVE_CERTIFICATE_NOT_FOUND",
  CRYPTO_PLUGIN_IS_INACTIVE = "CRYPTO_PLUGIN_IS_INACTIVE",
}

export const DEFAULT_ERROR_TITLE = "Произошла ошибка!";

export const CUSTOM_ERROR_TITLES = {
  [CUSTOM_ERROR_KEYS.EXCEEDED_THE_LIMIT]: "Лимит документов превышен",
  [CUSTOM_ERROR_KEYS.ACTIVE_CERTIFICATE_NOT_FOUND]:
    "Действующий сертификат не найден",
  [CUSTOM_ERROR_KEYS.INVALID_PINCODE]: "Подписание остановлено",
  [CUSTOM_ERROR_KEYS.CRYPTO_PLUGIN_IS_INACTIVE]: "Плагин недоступен",
};

export const CUSTOM_ERROR_ANNOTATIONS = {
  [CUSTOM_ERROR_KEYS.ACTIVE_CERTIFICATE_NOT_FOUND]:
    "Обратитесь в Банк - в отделение или по телефону",
  [CUSTOM_ERROR_KEYS.EXCEEDED_THE_LIMIT]:
    "Сократите количество выбранных рублёвых документов в истории платежей",
  [CUSTOM_ERROR_KEYS.INVALID_PINCODE]: "Пароль введён неверно",
};

export const CRYPTO_PLUGIN_IS_INACTIVE_LINK =
  "https://www.cryptopro.ru/sites/default/files/products/cades/demopage/cades_bes_sample.html";
export const CRYPTO_PLUGIN_IS_INACTIVE_ANNOTATION_BEGIN =
  "Необходимо проверить работу";
export const CRYPTO_PLUGIN_IS_INACTIVE_ANNOTATION_END =
  "и перезагрузить страницу";

export type CUSTOM_ERROR_KEY = keyof typeof CUSTOM_ERROR_KEYS;

export const CUSTOM_ERROR_MAPPING: Record<string, CUSTOM_ERROR_KEY> = {
  "Сертификаты не найдены": CUSTOM_ERROR_KEYS.ACTIVE_CERTIFICATE_NOT_FOUND,
  "Lost connection to extension": CUSTOM_ERROR_KEYS.CRYPTO_PLUGIN_IS_INACTIVE,
};
